/**
 * Creates a landmark string on the landmark data passed in
 * @param landmarkDataInOrder - landmark data in the order of the appearance in the landmark data string
 * @returns {string|*}
 */
export function createLandmarkDataString(landmarkDataInOrder) {
    if(!landmarkDataInOrder) {
        return "";
    }

    return Object.keys(landmarkDataInOrder)
        .map((key) => landmarkDataInOrder[key])
        .reduce(handleLandmarkValue);
}

/**
 * Handles each value of the landmark data object
 * @param accumulator the accumulation of the string that is being created
 * @param landmarkValue the landmark value to be added
 * @returns {string} the current accumulation of the whole string including the new value
 */
function handleLandmarkValue(accumulator, landmarkValue) {
    return accumulator + "\\" + landmarkValue;
}

export default {
    createLandmarkDataString
};